var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.5 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #6533e9;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.08,18.42c1.01,0,1.83.82,1.83,1.83v6.45c0,1.24-.36,2.41-.97,3.4-1.13,1.81-3.13,3.02-5.42,3.04v-2.38c0-.27-.22-.5-.5-.5h-2.12c-.27,0-.49.22-.49.49v2.38h-11.33v-2.38c0-.27-.22-.5-.5-.5h-2.12c-.27,0-.49.22-.49.49v2.38c-2.28-.02-4.29-1.23-5.42-3.04-.61-.99-.97-2.15-.97-3.4v-6.45c0-1.01.82-1.83,1.83-1.83h26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.53,30.76v4.77c0,.27-.22.5-.5.5h-2.12c-.27,0-.49-.22-.49-.49v-4.77c0-.27.22-.5.5-.5h2.12c.27,0,.49.22.49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.08,30.76v4.77c0,.27-.22.5-.5.5h-2.12c-.27,0-.49-.22-.49-.49v-4.77c0-.27.22-.5.5-.5h2.12c.27,0,.49.22.49.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.94,30.1v9.84c0,1.01-.82,1.83-1.83,1.83h-24.72c-1.01,0-1.83-.82-1.83-1.83v-9.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.13,18.42v-2.13c0-.67.54-1.2,1.2-1.2h6.83c.67,0,1.2.54,1.2,1.2v2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.75,34.38v-9.26l-7.17-.99c-.53-2.08-1.35-4.04-2.42-5.84l4.36-5.77-6.55-6.55-5.77,4.36c-1.8-1.07-3.76-1.88-5.84-2.42l-.99-7.17h-9.26l-.99,7.17c-2.08.53-4.04,1.35-5.84,2.42l-5.77-4.36-6.55,6.55,4.36,5.77c-1.07,1.8-1.88,3.76-2.42,5.84l-7.17.99v9.26l7.17.99c.53,2.08,1.35,4.04,2.42,5.84l-4.36,5.77,6.55,6.55,5.77-4.36c1.8,1.07,3.76,1.88,5.84,2.42l.99,7.17h9.26l.99-7.17c2.08-.53,4.04-1.35,5.84-2.42l5.77,4.36,6.55-6.55-4.36-5.77c1.07-1.8,1.88-3.76,2.42-5.84l7.17-.99Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.05c2dea905857c478245127d1060a4dc.svg";
export { ForwardRef as ReactComponent };